<template>
  <main class="page-apis page-main__wrapper layout">
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <a href="javascript:void(0);" @click="$_goTo">审核记录</a>
      <span class="split">/</span>
      <span class="active">查看审核记录</span>
    </div>

    <div class="content" ref="main-scroll">
      <div class="cd-item" ref="markup1">
        <div class="label">基本信息</div>
        <div class="con base-info">
          <span>接口类型：{{ contData.portType | portType }}</span>
          <span v-if="contData.portType == 2">运营商：{{ contData.platformName }}</span>
          <span v-if="contData.portType == 2">品牌：{{ contData.brandName }}</span>
          <span v-if="contData.portType == 2">供应商订阅名称：{{ contData.viewName }}</span>
        </div>
      </div>
      <div class="cd-item" ref="markup2">
        <div class="label">申请理由</div>
        <div class="con">
          <div class="box brd">{{ contData.applyReason }}</div>
        </div>
      </div>
      <div class="cd-item" ref="markup3">
        <div class="label">审核意见</div>
        <div class="con">
          <div class="row result">审核结果：{{ contData.auditStatus | auditStatus }}</div>
          <div class="row result">审核理由：</div>
          <div class="box brd">{{ contData.auditRemark }}</div>
        </div>
      </div>
      <div class="cd-item" ref="markup3">
        <div class="label">邮件通知</div>
        <div class="con">
          <div class="row result">是否邮件通知：<el-button class="send__btn" @click="$_send_emails">确认通知</el-button></div>
        </div>
      </div>
      <div class="version-compare" :class="{one: !historyVersion}" v-if="!isLoading">
        <div class="curr-version">
          <div class="cd-item">
            <div class="label">提交版本{{historyVersion ? ' & 历史版本': ''}}</div>
            <div class="scroll-box">
              <el-scrollbar>
                <div class="con">
                  <div class="box">
                    <div class="block">
                      <!-- 当前版本 -->
                      <div class="cd-item">
                        <div class="label">基本配置</div>
                        <div class="con base-info">
                          <div class="row">
                            <span 
                              :class="{diff: historyVersion && contData.apiName != historyVersion.apiName }"
                              >接口名称：{{ contData.apiName }}</span>
                            <span
                              :class="{diff: historyVersion && contData.sendType != historyVersion.sendType}"
                              >发送类型：{{ contData.sendType | sendType }}</span>
                            <span
                              :class="{diff: historyVersion && contData.actionName != historyVersion.actionName }"
                              >ActionName：{{ contData.actionName }}</span>
                          </div>
                          <div class="row">
                            <div 
                              class="txt-box"
                              :class="{diff: historyVersion && contData.description != historyVersion.description }"
                              >
                              <span class="lab">接口说明：</span>
                              <span class="con">{{ contData.description }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div 
                              class="txt-box"
                              :class="{diff: historyVersion && contData.remark != historyVersion.remark }"
                              >
                              <span class="lab">备注：</span>
                              <span class="con">{{ contData.remark }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <span
                              :class="{diff: historyVersion && contData.invokeControl != historyVersion.invokeControl }"
                              >调用频次控制：{{ contData.invokeControl == null ? '' : contData.invokeControl == 0 ? '关闭':'开启' }}</span>
                            <span
                              :class="{diff: historyVersion && contData.timeType != historyVersion.timeType }"
                              >调用时间：{{ contData.timeType | timeType }}</span>
                            <span
                              :class="{diff: historyVersion && contData.dailyInvokeAmount != historyVersion.dailyInvokeAmount }"
                              >每天调用总量次数：{{ contData.dailyInvokeAmount }}</span>
                            <span
                              :class="{diff: historyVersion && contData.tps != historyVersion.tps }"
                              >每分钟处理频率（tps）：{{ contData.tps }}</span>
                            <span
                              :class="{diff: historyVersion && contData.status != historyVersion.status }"
                              >状态：{{ contData.status | status }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- 历史版本 -->
                      <div class="cd-item" v-if="historyVersion">
                        <div class="label">基本配置</div>
                        <div class="con base-info">
                          <div class="row">
                            <span>接口名称：{{ historyVersion.apiName }}</span>
                            <span>发送类型：{{ historyVersion.sendType | sendType }}</span>
                            <span>ActionName：{{ historyVersion.actionName }}</span>
                          </div>
                          <div class="row">
                            <div class="txt-box">
                              <span class="lab">接口说明：</span>
                              <span class="con">{{ historyVersion.description }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="txt-box">
                              <span class="lab">备注：</span>
                              <span class="con">{{ historyVersion.remark }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <span>调用频次控制：{{ historyVersion.invokeControl == null ? '' : historyVersion.invokeControl == 0 ? '关闭':'开启' }}</span>
                            <span>调用时间：{{ historyVersion.timeType | timeType }}</span>
                            <span>每天调用总量次数：{{ historyVersion.dailyInvokeAmount }}</span>
                            <span>每分钟处理频率（tps）：{{ historyVersion.tps }}</span>
                            <span>状态：{{ historyVersion.status | status }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="block">
                      <!-- 当前版本 -->
                      <div class="cd-item">
                        <div class="label">请求参数</div>
                        <div class="con">
                          <el-table
                            class="params-table"
                            :data="reqparamsTree"
                            row-key="uid"
                            border
                            default-expand-all
                            :row-class-name="rowStyle"
                            :tree-props="{children: 'children'}"
                          >
                            <el-table-column label="字段名称" prop="name"></el-table-column>
                            <el-table-column label="类型" width="70">
                              <template slot-scope="scope">
                                <span>{{ scope.row.type | parmType }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="正则校验值" width="120" prop="regex"></el-table-column>
                            <el-table-column label="长度" width="70" prop="size"></el-table-column>
                            <el-table-column label="是否必传" width="80">
                              <template slot-scope="scope">
                                <span>{{ scope.row.required | requiredDesc }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="说明"  prop="desc"></el-table-column>
                          </el-table>
                        </div>
                      </div>
                      <!-- 历史版本 -->
                      <div class="cd-item" v-if="historyVersion">
                        <div class="label">请求参数</div>
                        <div class="con">
                          <el-table
                            class="params-table"
                            :data="hisreqparamsTree"
                            row-key="uid"
                            border
                            default-expand-all
                            :tree-props="{children: 'children'}"
                          >
                            <el-table-column prop="name" label="字段名称"></el-table-column>
                            <el-table-column label="类型" width="70">
                              <template slot-scope="scope">
                                <span>{{ scope.row.type | parmType }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="regex" label="正则校验值" width="120"></el-table-column>
                            <el-table-column prop="size" label="长度" width="70"></el-table-column>
                            <el-table-column label="是否必传" width="80">
                              <template slot-scope="scope">
                                <span>{{ scope.row.required | requiredDesc }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="desc" label="说明"></el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                    <div class="block">
                      <!-- 当前版本 -->
                      <div class="cd-item">
                        <div class="label">返回参数</div>
                        <div class="con">
                          <el-table
                            class="params-table"
                            :data="resparamsTree"
                            row-key="uid"
                            border
                            default-expand-all
                            :row-class-name="rowStyle"
                            :tree-props="{children: 'children'}"
                          >
                            <el-table-column prop="name" label="字段名称"></el-table-column>
                            <el-table-column label="类型" width="70">
                              <template slot-scope="scope">
                                <span >{{ scope.row.type | parmType }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="regex" label="正则校验值" width="120"></el-table-column>
                            <el-table-column prop="size" label="长度" width="70"></el-table-column>
                            <el-table-column prop="desc" label="说明"></el-table-column>
                          </el-table>
                        </div>
                      </div>
                      <!-- 历史版本 -->
                      <div class="cd-item" v-if="historyVersion">
                        <div class="label">返回参数</div>
                        <div class="con">
                          <el-table
                            class="params-table"
                            :data="hisresparamsTree"
                            row-key="uid"
                            border
                            default-expand-all
                            :tree-props="{children: 'children'}"
                          >
                            <el-table-column prop="name" label="字段名称"></el-table-column>
                            <el-table-column label="类型" width="70">
                              <template slot-scope="scope">
                                <span>{{ scope.row.type | parmType }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="regex" label="正则校验值" width="120"></el-table-column>
                            <el-table-column prop="size" label="长度" width="70"></el-table-column>
                            <el-table-column prop="desc" label="说明"></el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>

                    <div class="block">
                      <!-- 当前版本 -->
                      <div class="cd-item">
                        <div class="label">请求示例</div>
                        <div class="con">
                          <textarea class="code-box" v-model="contData.reqSample" disabled></textarea>
                        </div>
                      </div>
                      <!-- 历史版本 -->
                      <div class="cd-item" v-if="historyVersion">
                        <div class="label">请求示例</div>
                        <div class="con">
                          <textarea class="code-box" v-model="historyVersion.reqSample" disabled></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="block">
                      <!-- 当前版本 -->
                      <div class="cd-item">
                        <div class="label">返回示例</div>
                        <div class="con">
                          <textarea class="code-box" disabled  v-model="contData.rspSample"></textarea>
                        </div>
                      </div>
                      <!-- 历史版本 -->
                      <div class="cd-item" v-if="historyVersion">
                        <div class="label">返回示例</div>
                        <div class="con">
                          <textarea class="code-box" disabled  v-model="historyVersion.rspSample"></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="block">
                      <!-- 当前版本 -->
                      <div class="cd-item">
                        <div class="label">接口目录</div>
                        <div class="con">
                          <div class="tree-box">
                            <el-tree
                              ref="rspcatalogTree"
                              :data="catalogs"
                              :props="defaultProps"
                              node-key="cid"
                              show-checkbox
                              check-strictly
                              default-expand-all
                              :default-checked-keys="catalogIds"
                              class="catalog-tree"
                            ></el-tree>
                          </div>
                        </div>
                      </div>
                      <!-- 历史版本 -->
                      <div class="cd-item" v-if="historyVersion">
                        <div class="label">接口目录</div>
                        <div class="con">
                          <div class="tree-box">
                            <el-tree
                              ref="reqcatalogTree"
                              :data="catalogs"
                              :props="defaultProps"
                              node-key="cid"
                              show-checkbox
                              check-strictly
                              default-expand-all
                              :default-checked-keys="this.historyVersion.catalogIds"
                              class="catalog-tree"
                            ></el-tree>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
export default {
  name: "apis-api-audit-logging-detail",
  props:{
    contData: { type: Object, default: {} },
    from: { type: String, default: '' },
  },
  data() {
    return {
      isLoading: false,
      menuIndex: 0,
      menu: ['基本信息', '申请理由', '审核意见', '接口配置'],
      allCatalogs: [],
      defaultProps: {
        children: "children",
        label: "cataogName"
      },
      catalogIds: [],
      historyVersion: null,
    };
  },
  computed: {
    catalogs() {
      return Utils.catalogsToTree(this.allCatalogs);
    },
    resparamsTree() {
      return Utils.paramListToTree(JSON.parse(JSON.stringify(this.contData.rspParam)));
    },
    reqparamsTree() {
      return Utils.paramListToTree(JSON.parse(JSON.stringify(this.contData.reqParam)));
    },
    hisresparamsTree() {
      return Utils.paramListToTree(JSON.parse(JSON.stringify(this.historyVersion.rspParam)));
    },
    hisreqparamsTree() {
      return Utils.paramListToTree(JSON.parse(JSON.stringify(this.historyVersion.reqParam)));
    },
  },
  filters: {
    portType(type){
      let str = "";
      if(type){
        str = type == 1 ? "标准接口" : "项目接口";
      }
      return str;
    },
    auditStatus(type){
      let str = "";
      if(type){
        str = type == 1 ? "审核中" : type == 2 ? "审核通过" : "审核不通过";
      }
      return str;
    },
    sendType(type){
      let str = "";
      if(type){
        str = type == 1 ? "转发" : type == 2 ? "分发" : "仅接收";
      }
      return str;
    },
    timeType(type){
      let str = "";
      if(type){
        str = type == 0 ? "长期" : "限时";
      }
      return str;
    },
    status(type){
      let str = "";
      if(type){
        str = type == 1 ? "启用" : type == 2 ? "停用" : "删除";
      }
      return str;
    },
    parmType(index){
      let str = "";
      let arr = ['String', 'Boolean', 'Int', 'Double', 'Long', 'Object', 'Array', '', 'Date' , 'Datetime', 'Float'];
      if(index){
        return arr[index-1]
      }
      return str;
    },
    requiredDesc(value) {
      return value === true ? "是" : "否";
    }
  },
  methods: {
    // 点击 取消
    $_goTo() {
      this.$emit('changeTab', {
        name: "auditComponent",
        from: 'auditDetailComponent'
      });
    },
    rowStyle({row}){
      let c1 = row.diff && row.diff.delRow ? 'del' : '';
      let c2 = row.diff && row.diff.allFalse ? 'diff' : '';
      return c1+' '+c2;
    },
    compareJson(){
      // 对比新增修改的
      this.contData.reqParam.map(ele => {
        let {arrayType, desc, name, parent, parentIndex, regex, required, size, type} = ele;
        let tempEle = {arrayType, desc, name, parent, parentIndex, regex, required, size, type};

        let node = this.historyVersion.reqParam.find(item => ele.parent == item.parent && ele.name == item.name);
        let tempNode;
        if(node){
          let {arrayType, desc, name, parent, parentIndex, regex, required, size, type} = node;
          tempNode = {arrayType, desc, name, parent, parentIndex, regex, required, size, type};
        }
        if(JSON.stringify(tempNode) != JSON.stringify(tempEle)){
          ele.diff = {};
          ele.diff.allFalse = true;
        }
      });
      this.contData.rspParam.map(ele => {
        let {arrayType, desc, name, parent, parentIndex, regex, required, size, type} = ele;
        let tempEle = {arrayType, desc, name, parent, parentIndex, regex, required, size, type};
        let node = this.historyVersion.rspParam.find(item => ele.parent == item.parent && ele.name == item.name);
        let tempNode;
        if(node){
          let {arrayType, desc, name, parent, parentIndex, regex, required, size, type} = node;
          tempNode = {arrayType, desc, name, parent, parentIndex, regex, required, size, type};
        }
        if(JSON.stringify(tempNode) != JSON.stringify(tempEle)){
          ele.diff = {};
          ele.diff.allFalse = true;
        }
      });

      // 对比减的字段
      let curr1 = [];
      this.historyVersion.reqParam.map(ele => {
        let node = this.contData.reqParam.find(item => ele.parent == item.parent && ele.name == item.name);
        if(!node){
          ele.diff = {};
          ele.diff.delRow = true;
          ele.diff.allFalse = true;
          curr1.push(JSON.parse(JSON.stringify(ele)));
        }
      });
      this.contData.reqParam.push(...curr1);

      let curr2 = [];
      this.historyVersion.rspParam.map(ele => {
        let node = this.contData.rspParam.find(item => ele.parent == item.parent && ele.name == item.name);
        if(!node){
          ele.diff = {};
          ele.diff.delRow = true;
          ele.diff.allFalse = true;
          curr2.push(JSON.parse(JSON.stringify(ele)));
        }
      });
      this.contData.rspParam.push(...curr2);
    },
    $_send_emails(){
      this.$service.post('sendPortAuditNoticeMail',{
        sendType: 2,
        aid: this.contData.aid,
      }).then(result => {
        if (result.$.checkResult(result, true)) {
          $MessageBox.alert({
            content: result.msg
          });
        }
      });
    }
  },
  async created() {
    this.isLoading = true;
    let actionName = '';
    let postData = {}
    if(this.contData.auditStatus == 2){
      actionName = 'getBeforeCurrentAuditPassVersion';
      postData = {
        aid: this.contData.aid,
      }
    }else{
      actionName = 'getPortLastAuditPassPortAudit';
      postData = {
        pid: this.contData.pid,
        portType: this.contData.portType,
        subscribeId: this.contData.subscribeId
      }
    }
    let p1 = this.$service.post(actionName, postData);
    let p2 = this.$service.post("findAllCatalog");

    const [result1, result2] = await Promise.all([p1, p2]);
    this.isLoading = false;
    if (result1.$.checkResult(result1, true)) {
      if(result1.data){
        let data = result1.data;
        //处理相同key， update报错问题
        data.reqParam.map(ele => {
          ele.uid= 'h-' + ele.uid;
          return ele;
        });
        data.reqParam.map(ele => {
          ele.uid= 'h-' + ele.uid;
          return ele;
        });
        this.historyVersion = data;
        this.compareJson();
      }
    }

    if (result2.$.checkResult(result2, true)) {
      this.allCatalogs = result2.data.filter(item => item.cataogType === 1);
    } else {
      return false;
    }
    this.catalogIds = this.contData.catalogIds;
    this.allCatalogs.map(ele => {
      ele.disabled = true;
    });
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  .content{
    flex: 1;
    padding: 0 0 0px 20px;
    margin-bottom: 70px;
    font-size: 12px;
    color:rgba(83,83,83,1);
    overflow: auto;
    .block{
      display: flex;
      .cd-item{
        max-width: 880px;
        flex: 1;
        overflow: hidden;
        &:last-child{
          margin-left: 20px;
        }
      }
    }
    .cd-item{
      margin-bottom: 20px;
      .label{
        line-height: 100%;
        color: #384E8C;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 10px;
      }
      .con{
        .box{
          min-height:68px;
          background:#FCFCFC;
          line-height:20px;
          padding: 10px 30px 10px 10px;
          &.brd{
            border: 1px solid #bccad0;
            max-width: 900px;
          }
          &.w1400{
            width: auto;
            min-width: 900px;
            max-width: 1400px;
            padding: 20px;
          }
        }
        .row{
          &.result{
            line-height: 20px;
            margin-bottom: 6px;
          }
        }
        &.base-info{
          span{
            display: inline-block;
            min-width: 220px;
            margin-right: 20px;
            line-height: 28px;
            white-space: nowrap;
          }
          .txt-box{
            width: 100%;
            white-space: normal;
            word-break: break-all;
            display: flex;
            .lab{
              width: auto;
              min-width: 0;
              margin-right: 0;
            }
            .con{
              padding: 4px 0;
              flex: 1;
              width: auto;
              overflow: hidden;
              white-space: normal;
              word-break: break-all;
              line-height: 20px;
            }
          }
        }
        /deep/ .params-table{
          width: 100%;
          background:rgba(255,255,255,1);
          border: 1px solid #BCCAD0;
          border-right: none;
          border-bottom: none;
          .el-table__header-wrapper .el-table__header{
            background-color: #fff;
             border-collapse: collapse;
          }
          .el-table__body{
            border-collapse: collapse;
            .del{
              .cell{
                text-decoration: line-through;
              }
            }
            .diff{
              .cell{
                color: #F86D38;
              }
            }
          }
          td,th{
            .cell{
              text-align: left;
              padding: 6px 14px;
              line-height: 16px;
              overflow: visible;
              text-emphasis: none;
              white-space: normal;
              word-break: break-all;
            }
          }
          td{
            border-right: 1px solid #BCCAD0;
            border-bottom: 1px solid #BCCAD0;
          }
          th{
            color: #384E8C;
            border-right: 1px solid #BCCAD0;
            &.is-leaf {
              border-bottom: 1px solid #BCCAD0;
            }
          }
          .el-table__row{
            background-color: #fff;
            & > td {
              padding: 0;
            }
            .el-table__expand-icon {
              display: inline-block;
              width: 20px;
              line-height: 20px;
              height: 20px;
              text-align: center;
              margin-right: 3px;
              transition: transform .2s ease-in-out;
            }
            .el-table__expand-icon--expanded {
              transform: rotate(90deg);
            }
          }
          &:after{
            background-color: #BCCAD0;
          }
          .el-table__placeholder {
            display: inline-block;
            width: 16px;
          }
          .el-table__empty-block{
            border-bottom: 1px solid #BCCAD0;
          }
        }

        .code-box{
          width: 100%;
          max-width:880px;
          height:268px;
          background:rgba(45,45,45,1);
          border:1px solid rgba(188,202,208,1);
          overflow-y: auto;
          color: #CCCCCC;
          line-height:20px;
          padding: 8px 12px;
        }

        .tree-box{
          max-width: 880px;
          height:268px;
          padding: 10px;
          background:rgba(252,252,252,1);
          border:1px solid rgba(188,202,208,1);
          overflow-y: auto;
        }
        /deep/ .el-tree{
          .el-tree-node__label{
            font-weight: normal;
            font-size: 12px;
          }
        }
        .diff{
          color: #F86D38;
        }
      }
    }
    .version-compare{
      padding-right: 15px;
      overflow: hidden;
      .curr-version{
        .scroll-box{
          border:1px solid rgba(188,202,208,1);
          height: 800px;
          background: #fcfcfc;
        }
        /deep/ .el-scrollbar{
          height: 100%;
          .el-scrollbar__wrap{
            padding-right: 12px;
            height: calc(100% + 17px);
          }
          .is-vertical{
            right: 2px;
          }
        }
      }
    }
    /deep/ .el-form-item__label{
      color: #535353;
    }
    /deep/ .send__btn{
      min-width: 80px;
      height: 30px;
      padding: 0 10px;
      font-size: 13px;
      color: #fff;
      background-color: #1895dd;
      border-color: transparent;
      vertical-align: middle;
      &:hover {
        background-color: #36a9ec;
      }
    }
  }
  .breadcrumb{
    margin-bottom: 32px;
  }
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  // min-height: 120px;
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 52px;
  }
}

.table-box {
  flex: 1;
  overflow-x: auto;
  position: relative;
  /deep/ .el-table::after{
    display: none;
  }
  .cd-switch{
    margin-right: 10px;
  }
}

.sidebar-menu{
  position: fixed;
  left: 85%;
  top: 155px;
  padding: 0 0 60px 12px;
  border-left: 1px solid #E6E6E6;
  color: #303030;
  line-height: 100%;
  font-size: 12px;
  li{
    line-height: 100%;
    margin-top: 24px;
    font-size: 12px;
    a{
      font-size: 12px;
      color: #999;
      cursor: pointer;
    }
    &.active{
      position: relative;
      &::before{
        content: '';
        display: inline-block;
        height: 20px;
        border-left: 2px solid #384E8C;
        position: absolute;
        top: 50%;
        left: -13px;
        margin-top: -10px;
      }
      a{
        color: #384E8C;
      }
    }
  }
}
</style>


